// extracted by mini-css-extract-plugin
export default {"afterpayBtnWrapper":"G1-z","button":"H1-z","disabled":"I1-z","creditCard":"J1-z","wrapper":"K1-z"};